module.exports = __webpack_public_path__ + "img/peoples.039d9eac.png";